import styled from 'styled-components';
import colors from '../../assets/colors';

export const Header = styled.div`
  background-color: #222222;
  height: 100px;
  display: flex;
`;

export const Logo = styled.img`
  width: 60px;
  height: 60px;
  margin-top: 5px;
  cursor: pointer;
`;

export const ToggleButton = styled.div`
  margin-right: 20px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  
  .fa-bars {
    font-size: 20px;
    color: ${colors.white}
  }

  @media screen and (min-width: 1090px) {
    display: none;
  }
`;

export const NavBar = styled.nav`
  margin: ${props => (props.roleType !== 'employee' ? '0 auto' : '0 25px')};
  flex: ${props => (props.roleType !== 'employee' ? 'none' : '1')};

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
  }

  li {
    padding: 0 1.2rem;
  }

  a {
    color: #777777;
    font-weight: 600;
    text-decoration: none;
    padding: 35px 0;
    border-bottom: 4px solid transparent;
  }

  .active, a:hover {
    color: ${colors.white};
    border-bottom: 4px solid ${colors.primary};
  }

  @media screen and (max-width: 1089px) {
    display: none
  }
`;

export const StoreInfo = styled.div`
  display: flex;
  flex-direction: 'row';
  align-items: center;
  background-color: #2B2B2B;
  padding: 12px;
  border-radius: 10px;
  width: 270px;
  
  h2 {
    color: ${colors.white};
    font-size: 0.95rem;
    font-weight: 600;
    margin: 0 0 2px;
    letter-spacing: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 160px;
  }

  .store-available {
    width: ${props => (props.available ? '80px' : '90px')};
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    text-align: left;
    cursor: ${props => (props.roleType !== 'employee' && !props.blocked ? 'pointer' : 'default')};

    span {
      color: #777777;
      font-family: 'Open Sans', sans-serif;
      font-size: 0.8rem;
      border-bottom: 1px solid;
      height: 1.0rem;
    }

    .fa-circle {
      color: ${colors.primary};
      font-size: 7px;
      padding-right: 6px;
    }

    .fa-circle.closed { color: #FFC107; }
    .fa-circle.unavailable { color: ${colors.red}; }

    :hover { opacity: ${props => (props.roleType !== 'employee' && !props.blocked ? 0.8 : 1)} }
  }

  .fa-angle-down, .fa-angle-up {
    color: ${colors.primary};
    font-size: 1.4rem;
    padding: 12px 11px 11px;
    border-radius: 5px;
    background-color: #222;
    cursor: pointer;
  }

  .fa-angle-down:hover { opacity: 0.9 }

  @media screen and (max-width: 1089px) {
    display: none;
  }
`;

export const Avatar = styled.img`
  width: 35px;
  height: 35px;
  margin-right: 12px;
  border-radius: 50px;
  border: 4px solid #222;
`;
